import React, { forwardRef, Ref } from 'react';
import { SimpleIconProps } from '../icon.types';
import Icon from './Icon';

const svg = `<svg viewBox="0 0 24 24" fill="currentColor">
  <path d="M14.2603 20.9543L9 19.1092L4.42175 20.8913C4.02463 21.0485 3.65451 21.0041 3.3114 20.7579C2.96828 20.5117 2.79672 20.1757 2.79672 19.75V5.74999C2.79672 5.48949 2.87218 5.25796 3.0231 5.05541C3.174 4.85288 3.37771 4.70397 3.63425 4.60869L8.26032 3.03966C8.50489 2.96103 8.75145 2.91955 9 2.91521C9.24855 2.91086 9.49511 2.95434 9.73967 3.04564L15 4.89074L19.5782 3.10869C19.9754 2.95144 20.3455 2.99591 20.6886 3.24211C21.0317 3.4883 21.2033 3.82426 21.2033 4.24999V18.25C21.2033 18.5105 21.1278 18.742 20.9769 18.9446C20.826 19.1471 20.6223 19.296 20.3657 19.3913L15.7397 20.9603C15.4951 21.0389 15.2485 21.0804 15 21.0848C14.7514 21.0891 14.5049 21.0456 14.2603 20.9543ZM14 18.4663V6.93369L10 5.53369V17.0663L14 18.4663ZM16 18.4663L18.9282 17.4962V5.80759L16 6.93369V18.4663ZM5.07175 18.1924L8 17.0663V5.53369L5.07175 6.50379V18.1924Z"/>
</svg>`;

const Map = forwardRef(
  (props: SimpleIconProps, ref: Ref<SVGSVGElement> | undefined) => (
    <Icon ref={ref} name='map' svg={svg} {...props} />
  )
);

Map.displayName = 'MapIcon';

export default Map;
